var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"flat":""},on:{"submit":function($event){$event.preventDefault();}}},[_c('global-search-autocomplete',{attrs:{"results":_vm.results},on:{"searchChanged":_vm.searchChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }